import { render, staticRenderFns } from "./Ending.vue?vue&type=template&id=5c826f00&scoped=true&lang=pug&"
import script from "./Ending.vue?vue&type=script&lang=js&"
export * from "./Ending.vue?vue&type=script&lang=js&"
import style0 from "./Ending.vue?vue&type=style&index=0&id=5c826f00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c826f00",
  null
  
)

export default component.exports